"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var useStyles = core_1.makeStyles(function (theme) {
    var _a;
    return core_1.createStyles({
        root: (_a = {
                fontWeight: 400,
                background: theme.palette.secondary.main,
                borderRadius: '5px',
                color: 'white',
                paddingTop: theme.spacing(0.5),
                paddingBottom: theme.spacing(0.5),
                paddingRight: theme.spacing(1),
                paddingLeft: theme.spacing(1)
            },
            _a[theme.breakpoints.up('md')] = {
                fontWeight: 500,
            },
            _a),
        text: {
            fontSize: '0.75rem',
        },
    });
});
var BetaTag = function () {
    var classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(core_1.Typography, { variant: "body2", className: classes.text }, "BETA")));
};
exports.default = BetaTag;
